<template lang="es">
    <div>
         <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" md="8" sm="8" xs="12">
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="pb-0 mb-0">
                                Informadores municipales
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="mt-0 pt-0">
                                 <small v-if="nombreDepartamentoCreador">{{nombreDepartamentoCreador}}</small>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" md="4" sm="4" xs="12">
                        <v-btn v-if="currentRoles.includes(5)"
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Registrar nuevo
                        </v-btn>
                    </v-col> 
                </v-row>
    
                
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
            
                        
            <v-card-text>

                <v-row class="d-flex align-end flex-column mb-4">
                    
                    <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1 align-end">
                        <v-text-field
                            append-icon="mdi-magnify"
                            outlined
                            dense
                            v-model="filtroBusqueda"
                            label="Buscar"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                    :headers="headers"
                    :items="usuarios"
                    item-key="Id"
                    class="elevation-0"
                    :loading="tableLoading"
                    no-data-text="No hay datos para mostrar"
                    :search="filtroBusqueda"
                    :items-per-page="10"
                    dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.nombreUsuario }}</td>
                            <td>{{ item.correoUsuario }}</td>
                            <td>{{ item.municipio }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn v-if="currentRoles.includes(5)" class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>

                                <v-btn class="ma-2" small tile outlined color="indigo" @click="mostrarModalResetPass(item.nombreUsuario, item.id, item.correoUsuario)">
                                    <v-icon left>mdi-lock-reset</v-icon> Restablecer contrase&ntilde;a
                                </v-btn>

                                <!--
                                <v-btn class="ma-2" small tile outlined color="indigo"
                                    @click="descargarArchivo(`${baseIntUrl}${item.pathDocumentoRespaldo}`)">
                                    <v-icon left>mdi-cloud-download</v-icon> Documento respaldo
                                </v-btn>
                              -->

                                <v-btn class="ma-2" small tile outlined color="indigo"
                                    @click="descargarArchivo(`https://capacitacion.segeplan.gob.gt${item.pathDocumentoRespaldo}`)">
                                    <v-icon left>mdi-cloud-download</v-icon> Documento respaldo
                                </v-btn>

                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="700px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosUsuario.nombreUsuario"
                                label="Nombre del usuario"
                                :rules="[
                                    required(
                                        'Nombre del usuario'
                                    )
                                ]"
                            ></v-text-field>
                        </v-col>

                        <v-col  cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosUsuario.correoUsuario"
                                label="Correo electrónico"
                                :rules="[
                                    required(
                                        'Correo usuario'
                                    ),
                                    validEmail('')
                                ]"
                                :disabled="accion===2 && False"   
                            ></v-text-field>
                        </v-col> 
                       
                    </v-row>

                    <v-row>
                         <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosUsuario.puestosId"
                                :items="puestos"
                                class="required"
                                dense
                                outlined
                                :loading="ddPuestosLoading"
                                label="Puesto"
                                item-text="nombrePuesto"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'rol'
                                    )
                                ]"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                            <div v-if="archivoExiste">
                                <v-row>
                                    <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-0 mb-0 col-btn">
                                        <label class="grey--text body-2 mb-0">Documento respaldo</label>
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12" xs="12" class="pt-0">
                                        <v-btn class="ma-2 mt-0 mb-0 ml-0" medium tile outlined color="indigo"
                                            @click="descargarArchivo(`${baseIntUrl}${datosUsuario.pathDocumentoRespaldo}`)">
                                            <v-icon left>mdi-cloud-download</v-icon> Descargar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                
                            </div>

                            <div v-if="!archivoExiste">
                          
                                <template>

                                    <v-file-input
                                        id="respaldoFile"
                                        dense
                                        outlined
                                        placeholder="Seleccionar pdf de DPI"
                                        label="Documento de respaldo"
                                        append-icon="mdi-file-pdf-outline"
                                        prepend-icon=""
                                        accept="application/pdf,image/jpeg"
                                        @change="onFileChange"
                                        :rules="[fileRequired('Documento de respaldo')]"
                                        :show-size="1000"
                                        ref="respaldoFile"
                                        class="required"
                                    >
                                        <template v-slot:selection="{ index, text }">
                                            <v-chip
                                                v-if="index < 2"
                                                small
                                                label
                                                color="primary"
                                            >
                                                {{ text }}
                                            </v-chip>
                                            <span
                                                v-else-if="index === 2"
                                                class="text-overline grey--text text--darken-3 mx-2"
                                            >
                                                +{{ files.length - 2 }} archivo(s)
                                            </span>
                                        </template>
                                    </v-file-input>
                                </template>
                            </div>
                        </v-col>

                                              
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" sm="6" xs="12">
                            <v-select
                                v-model="datosUsuario.departamentoInformadorId"
                                :items="deptos"
                                :disabled="ddDepartamentoDisabled"
                                class="required"
                                dense
                                outlined
                                :loading="ddDeptosLoading"
                                label="Departamento"
                                item-text="nombreDepartamento"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Departamento'
                                    )
                                ]"
                                @change="obtnenerMunicipiosPorDepto()"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="6" sm="6" xs="12">
                            <v-select
                                v-model="datosUsuario.municipiosId"
                                :items="municipios"
                                class="required"
                                dense
                                outlined
                                :no-data-text="datosUsuario.departamentosId<1? 'Seleccione un departamento' : 'No se han encontrado municipios'"
                                :loading="ddMunicipiosLoading"
                                label="Municipio"
                                item-text="nombreMunicipio"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Municipio'
                                    )
                                ]"
                                
                            ></v-select>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <!-- Inicio:: Dialog para para restablecer contraseña-->
    <v-dialog
        v-model="dialogResetPass"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                Restablecer contrase&ntilde;a
                
                <v-spacer></v-spacer>
                <v-btn
                    icon

                    @click="dialogResetPass = false"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                    ref="resetPassForm"
                    v-on:submit.prevent="restablecerContrasenia"
                    >
            <v-card-text>
                <v-container>
                    <h4>Está seguro de restablecer la contrase&ntilde;a para {{nombreUsuario}}</h4>
                </v-container>
            </v-card-text>
            <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            :disabled="btnResetPassLoading"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogResetPass = false"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0"
                            :loading="btnResetPassLoading"                           
                        >
                            Restablecer
                        </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    

    <!-- Fin:: Dialog para restablecer contraseña-->
    <!-- Fin:: Dialog para mostrar los datos de la etnia-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";
import { mapGetters } from "vuex";
import { API_BASE_URL } from "@/core/services/api.service";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_USUARIOS_INFORMADORES, OBTENER_USUARIO_INFORMADOR, REGISTRAR_USUARIO_INFORMADOR, ACTUALIZAR_USUARIO_INFORMADOR} from "@/core/services/store/usuarios/usuarioinformador.module";
//import { OBTENER_REGIONES } from "@/core/services/store/region.module";
import { OBTENER_ROLES } from "@/core/services/store/rol.module";
import { OBTENER_PUESTOS } from "@/core/services/store/puesto.module";
import { OBTENER_DEPARTAMENTOS} from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_MUNICIPIOS_POR_DEPTO } from "@/core/services/store/catalogos/municipio.module";
import { CARGAR_ARCHIVO } from "@/core/services/store/cargaarchivo.module";
import { RESTABLECER_PASS_USUARIO } from "@/core/services/store/usuarios/usuario.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdminInformadores",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            baseIntUrl:'',
            tableLoading: false,
            validForm:false,
            ddPuestosLoading:false,
            ddDeptosLoading:false,
            ddDepartamentoDisabled:false,
            ddMunicipiosLoading:false,
            itemName : "Usuarios Institucionales",
            dialog: false,
            dialogResetPass:false,
            modalTitle: 'Registrar Usuario',
            btnRegistroLoading: false,
            btnResetPassLoading:false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Usuario',
            accion: 1,
            showPass:false,
            Pais_Id: 0,
            roles: [],
            puestos: [],
            deptos:[],
            departamentoId:0,
            municipios: [],
            usuarios: [],
            departamentos: [],
            switchItemEstado: true,
            nombreUsuario:'',
            idUsuario:0,
            filtroBusqueda: '',
            nombreDepartamentoCreador: null,
            datosUsuario: {
                id: 0,
                nombreUsuario: '',
                correoUsuario: '', 
                estadosId: 1,
                puestosId: 0,
                rolUsuarioId:4,
                institucionesId:null,
                municipiosId:0,
                pathDocumentoRespaldo: '',
                departamentoInformadorId:0,
                roles:[
                    {
                        idRol: 4
                    }
                ]
            },
            datosPass:{
                idUsuario: 0,
                correoUsuario: '',
                usuarioActualizacion: ''
             },
            archivoExiste: false,
            archivoRespaldo:[],
            archivoCargado: false,
            ...validations
        } 
    },
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Informador';
            this.btnRegistroText='Registrar Informador';
            if(parseInt(window.localStorage.getItem('creadorDepartamentoId'))){
                this.obtnenerMunicipiosPorDepto();
            }
            this.dialog=true;
            this.archivoExiste=false;
        },

        resetForm(){
            //this.$refs.form.reset();
            this.datosUsuario={
                id: 0,
                nombreUsuario: '',
                correoUsuario: '', 
                estadosId: 1,
                puestosId: 0,
                rolUsuarioId:4,
                institucionesId:null,
                municipiosId:0,
                pathDocumentoRespaldo: '',
                departamentoInformadorId:0,
                roles:[
                    {
                        idRol: 4
                    }
                ]
            };
            this.archivoExiste=false;
            //console.log(this.archivoRespaldo.size)
            if(this.archivoRespaldo && this.archivoRespaldo.size){
                this.archivoRespaldo=[];
                this.$refs.respaldoFile.reset();
                //this.$refs['respaldoFile'][0].reset();
            }
            this.archivoRespaldo=[];
            this.archivoCargado=false;
            this.switchItemEstado = true;
            this.municipios=[];

             if(parseInt(window.localStorage.getItem('creadorDepartamentoId'))){
                this.datosUsuario.departamentoInformadorId = parseInt(window.localStorage.getItem('creadorDepartamentoId'));
                this.ddDepartamentoDisabled=true;
             }
        },

        onFileChange(e){
            if(e){
                //!?Validar que el tipo de archivo sea pdf
                if (e.type != "application/pdf" && e.type != "image/jpeg" ){
                    // Api call
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `El archivo que desea ingresar no es válido.`);
                    //console.log("no es un pdf..")
                    //this.$refs.file.reset();
                    document.querySelector('#respaldoFile').value = '';
                    this.$refs.respaldoFile.reset();
                    return false;
                }
                //?Validar que el tamaó del archivo no exceda los 5Mb
                if ((e.size/1024/1024) > 5){
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `El tamaño del archivo excede el límite permitido (5Mb)`);
                    // this.$refs.file.reset();
                    document.querySelector('#respaldoFile').value = '';
                    this.$refs.respaldoFile.reset();
                    return false;
                }

                this.archivoRespaldo = e;
            }
        },

        //!Obtener los roles para asignar al usuario
        async obtenerRoles(){
            this.roles=[];
            await this.$store
                .dispatch(OBTENER_ROLES)
                .then(res => {
                    if(res.status===200){
                    this.roles = this.$store.state.rol.roles;
                    }
                })
                .catch(err => {
                    console.log(err)
                });
            return;
        },

        //!Obtener los roles para asignar al usuario
        async obtenerPuestos(){
            this.ddPuestosLoading =true;
            this.puestos=[];
            await this.$store
                .dispatch(OBTENER_PUESTOS, 1)
                .then(res => {
                    if(res.status==200){
                        this.puestos = this.$store.state.puesto.puestos;
                    }
                    this.ddPuestosLoading =false;
                //console.log(this.etnias)
                })
                .catch(err => {
                    this.ddPuestosLoading =false;
                    console.warn(err)
                });
        },


        //!Obtener los departamentos para la tabla
        async obtnenerDepartamentos(){
            this.ddDeptosLoading = true;
            this.deptos=[];
            
            await this.$store
                .dispatch(OBTENER_DEPARTAMENTOS,1)
                .then(res => {
                    if(res.status==200){
                        this.deptos = this.$store.state.departamento.departamentos;
                    }
                    this.ddDeptosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddDeptosLoading = false;
                });

        },


        //!Obtener las etnias para la tabla
        async obtnenerMunicipiosPorDepto(){
           // console.log("dsfsdf")
            //this.departamentoId = this.datosUsuario.departamentosId;
            this.ddMunicipiosLoading = true;
            this.municipios=[];
            
            await this.$store
                .dispatch(OBTENER_MUNICIPIOS_POR_DEPTO, {departamentoId: this.datosUsuario.departamentoInformadorId, estadoId: 1})
                .then(res => {
                    if(res.status==200){
                        this.municipios = this.$store.state.municipio.municipios;
                    }
                    this.ddMunicipiosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddMunicipiosLoading = false;
                });

        },

       

        //!Obtener informadores municipales
        //Si departamentoId = 0 obtiene todos, de lo contrario obtiene los asignados al depto del creador logueado.
        async obtnenerItems(){
            console.log(this.departamentoId)
            this.tableLoading = true;
            this.usuarios=[];
            //console.log('22')
            await this.$store
                .dispatch(OBTENER_USUARIOS_INFORMADORES, this.departamentoId)
                .then(res => {
                    if(res.status===200){
                        this.usuarios = this.$store.state.usuarioinformador.usuariosInformadores;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosUsuario.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Informador';
            this.btnRegistroText='Actualizar Informador';

            this.$store
                .dispatch(OBTENER_USUARIO_INFORMADOR, Id)
                .then(res => {
                    if(res.status===200){
                    this.datosUsuario = this.$store.state.usuarioinformador.usuarioInformador;
                    this.datosUsuario.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                    this.obtnenerMunicipiosPorDepto().then(()=>{
                        this.datosUsuario.municipiosId = this.$store.state.usuarioinformador.usuarioInformador.municipiosId;
                    })
                    this.verificarArchivo(this.baseIntUrl+this.datosUsuario.pathDocumentoRespaldo)
                        //this.obtenerDepartamentos().then(()=>{
                    this.dialog = true;
                            
                    } else{
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderVisible = false;
                    //});
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },
        
       
        registrarItem(){

            this.btnRegistroLoading=true;


            if(!this.archivoExiste){
                //Cargar Archivo de respaldo
                this.cargarArchivoRespaldo()
                .then(() => {
                
                    //?Validar que el archivo fue cargado
                    if(this.archivoCargado){
                        this.registrarInformador();
                    } else {
                        this.btnRegistroLoading=false;
                    }
                })
                .catch(() => {
                    this.btnRegistroLoading=false;
                }); 
            } else {
                this.registrarInformador();
            }
        },

        //!Cargar el documento de respaldo para el informador
        async cargarArchivoRespaldo(){
            const file = this.archivoRespaldo;

            await 
                this.$store.dispatch(CARGAR_ARCHIVO, {file:file, path: '\\documentos\\municipalidades\\informadores\\respaldos\\'})
                .then(res => {
                    //console.log(res)
                    if(res.status===200){
                        this.archivoCargado = true;
                        this.datosUsuario.pathDocumentoRespaldo = res.pathArchivo;
                        return true;
                    }
                    else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        this.archivoCargado = false;
                        return false;
                    }
                })
                .catch(() => {
                    //console.log(error)
                    return false;
                   
                });
        },

        //!Registrar al informador luego de cargar el arhcivo
        async registrarInformador(){
            this.switchItemEstado ? this.datosUsuario.estadosId = 1 : this.datosUsuario.estadosId = 2;

                if(this.accion===1){
                    this.datosUsuario.id = 0;
                    await this.$store
                        .dispatch(REGISTRAR_USUARIO_INFORMADOR, this.datosUsuario)
                        .then(res => {
                            //console.log(res)
                            if(res.status===200){
                                this.obtnenerItems();
                                this.dialog=false;
                                this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                                this.resetForm();
                                this.switchItemEstado = true;
                                this.archivoCargado=false;
                            } else {
                                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                            }
                            this.btnRegistroLoading=false;
                        })
                        .catch(error => {
                            //console.log(error)
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                            this.btnRegistroLoading=false;
                        });

                            

                } else {
                    this.datosUsuario.muniInformadorId = this.datosUsuario.muniInformador;

                    await this.$store
                        .dispatch(ACTUALIZAR_USUARIO_INFORMADOR, this.datosUsuario)
                        .then(res => {
                            //console.log(res)
                            if(res.status===200){
                                this.obtnenerItems();
                                this.dialog=false;
                                this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                                this.resetForm();
                                this.switchItemEstado = true;
                                
                            } else {
                                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                            }
                            this.btnRegistroLoading=false;
                        })
                        .catch(error => {
                            //console.log(error)
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                            this.btnRegistroLoading=false;
                        });
                }
        },

        //!Validar que el arhcivo exista
        verificarArchivo(path){
            //console.log(path)
            try{
                var xhr = new XMLHttpRequest();
                xhr.open('HEAD', path, false);
                xhr.send();
                xhr.status===200 ? this.archivoExiste = true : this.archivoExiste = false;
                return xhr.status !== 404;
            } catch(err){
                console.log(err)
            }

            
        },

        //!Descargar el archivo de respaldo
        descargarArchivo(path){
            window.open(path, "_blank");
        },

        /**
        * Modal de confirmacion de cambio de contraseña
        */
       mostrarModalResetPass(nombreUsuario, id, correoUsuario){
           this.dialogResetPass=true;
           this.nombreUsuario = nombreUsuario;
           this.datosPass.idUsuario = id;
           this.datosPass.correoUsuario = correoUsuario;
           this.datosPass.usuarioActualizacion = id.toString();
       },

       /**
        * Restablecer la contraseña del usuario master institucion
        */
       restablecerContrasenia(){
           this.btnResetPassLoading = true;
           this.$store
           .dispatch(RESTABLECER_PASS_USUARIO, this.datosPass)
           .then(res => {
               if(res.status==200){
                   this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                   this.dialogResetPass = false;
               } else {
                   this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error durante la actualización.`);
               }
               this.btnResetPassLoading = false;
            })
           .catch(err => {
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema. REF: ${err}`);
                this.btnResetPassLoading = false;
            });


       }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Informadores Municipales" }
        ]);
    },

    created(){
       
        this.obtenerRoles();
        this.obtenerPuestos();
        this.obtnenerDepartamentos();
        this.baseIntUrl = API_BASE_URL;

        //console.log(window.localStorage.getItem('rolId'))
        /*if(parseInt(window.localStorage.getItem('rolId'))===5){
            if(parseInt(window.localStorage.getItem('creadorDepartamentoId'))){
                this.datosUsuario.departamentoInformadorId = parseInt(window.localStorage.getItem('creadorDepartamentoId'));
                this.nombreDepartamentoCreador = window.localStorage.getItem('creadorDepartamentoNombre');
                this.ddDepartamentoDisabled=true;
                this.obtnenerMunicipiosPorDepto();
            }
        }*/

        let stRoles = window.localStorage.getItem('roles');
                
        if(stRoles.includes(5)){
            if(parseInt(window.localStorage.getItem('creadorDepartamentoId'))){
                
                this.datosUsuario.departamentoInformadorId = parseInt(window.localStorage.getItem('creadorDepartamentoId'));
                this.departamentoId = this.datosUsuario.departamentoInformadorId;
                this.nombreDepartamentoCreador = window.localStorage.getItem('creadorDepartamentoNombre');
                this.ddDepartamentoDisabled=true;
                this.obtnenerMunicipiosPorDepto();
                //console.log(this.departamentoId)
            }
        }

         this.obtnenerItems();
    },

    computed: {
         
        //...mapGetters(["getInterfaceBaseUrl"]),
        ...mapGetters(["currentUser"]),
        ...mapGetters(["currentRoles"]),

        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre del usuario",
                    value: "nombreUsuario"
                },
                                {
                    text: "Correo",
                    value: "correoUsuario"
                },
                {
                    text: "Municipalidad",
                    value: "municipalidadesId"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>